<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="'全部车辆(' + numArr.insuranceStateCount + ')'"
        name="1"
      ></el-tab-pane>
      <el-tab-pane
        :label="'交强险即将逾期(' + numArr.strongRiskExpres30Days + ')'"
        name="2"
      ></el-tab-pane>
      <el-tab-pane
        :label="'交强险已过期(' + numArr.strongRiskExpired + ')'"
        name="3"
      ></el-tab-pane>
      <el-tab-pane
        :label="'商业险即将逾期(' + numArr.businessRiskExpres30Days + ')'"
        name="4"
      ></el-tab-pane>
      <el-tab-pane
        :label="'商业险已过期(' + numArr.businessRiskExpres + ')'"
        name="5"
      ></el-tab-pane>
    </el-tabs>
    <div class="selectBox">
      <el-form ref="paramsList" :model="params">
        <QS-search maxLine="2" ref="BLM-search">
          <!-- 内容区域-->
          <el-form-item label="车辆ID" prop="carId">
            <el-input
              v-model.trim="params.carId"
              clearable
              placeholder="请输入车辆ID"
              v-number:integer="18"
            />
          </el-form-item>
          <el-form-item label="车牌号" prop="plateNo">
            <el-select
              v-model="params.plateNo"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="请输入"
              :remote-method="remoteMethod"
              :loading="oLoading.fuzzy"
            >
              <el-option
                v-for="item in options"
                :key="'options' + item.id"
                :label="item.plateNo"
                :value="item.plateNo"
              />
            </el-select>
          </el-form-item>
          <CarBrandSeriesModel
            ref="carBrandSeriesModelRef"
            v-model="brandSeriesModel"
            :showModel="true"
            :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
            >
          </CarBrandSeriesModel>
          <el-form-item label="所属部门" prop="deptIdList">
            <DeptSelect v-model="params.deptIdList" filterable clearable multiple/>
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                :loading="oLoading.search"
                type="primary"
                size="small"
                @click="selectBtn"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="Reset"> 重置 </el-button>
            </el-form-item>
            <el-form-item>
              <!-- <el-button type="primary" size="small"> 导出数据 </el-button> -->
              <export
                :exportTemplate="exportTemplate"
                filename="车险管理列表.xlsx"
                :params="exportParams"
                v-if="judgePermission('vehicle_insurance_manage_list_export')"
              />
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <div class="content">
      <QS-common-table
        :data="tableData"
        :columns="headColumn"
        :pagination="paginationData"
        :loading="oLoading.search"
        @change="paginationEvent"
      />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { FuzzySearch } from '@/api/domain/cars'
import { insuranceSummary, insuranceList } from '@/api/domain/carsService'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  data() {
    return {
      oLoading: {
        search: false,
        fuzzy: false,
      },
      exportTemplate: 'Insurance',
      activeName: '1',
      params: {
        carId: '',
        plateNo: '',
        tagType: 1,
        destination: 1,
        pageSize: 10,
        pageNum: 1,
        deptIdList: [],
      },
      brandSeriesModel: {},
      total: 10,
      headColumn: [
        {
          name: 'carId',
          columnProps: {
            label: '车辆ID',
            prop: 'carId',
            width: 110,
            fixed: 'left',
          },
          render: ({ row }) => {
            if (this.judgePermission('carDetails')) {
              return (
                row.carId && (
                  <span
                    style="cursor: pointer;color:#0059dc"
                    onClick={() => this.JumpCarEdit(row)}
                  >
                    {row.carId}
                  </span>
                )
              )
            } else {
              return <span>{row.carId}</span>
            }
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'brandName',
          columnProps: {
            label: '品牌',
            prop: 'brandName',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            label: '车系',
            prop: 'seriesName',
          },
        },
        {
          name: 'carModelName',
          columnProps: {
            label: '车型',
            prop: 'carModelName',
          },
        },
        {
          name: 'strongRiskEndDate',
          columnProps: {
            label: '交强险到期日',
            prop: 'strongRiskEndDate',
          },
        },
        {
          name: 'strongRiskRemaringDays',
          columnProps: {
            label: '交强险剩余天数',
            prop: 'strongRiskRemaringDays',
            width: 130,
          },
          render: ({ row }) => {
            if (row.strongRiskRemaringDays < 0) {
              return (
                <span style="color: red">{`已过期(${
                  row.strongRiskRemaringDays
                })`}</span>
              )
            }
            return <span>{row.strongRiskRemaringDays || '--'}</span>
          },
        },
        {
          name: 'businessRiskEndDate',
          columnProps: {
            label: '商业险到期日',
            prop: 'businessRiskEndDate',
          },
        },
        {
          name: 'businessRiskRemaringDays',
          columnProps: {
            label: '商业险剩余天数',
            prop: 'businessRiskRemaringDays',
            width: 135,
          },
          render: ({ row }) => {
            // 保险状态：3：暂停中
            if (row.state === 3) {
              return (
                <span style="color:gray">{`暂停中(${
                  row.businessRiskRemaringDays
                })`}</span>
              )
            }
            if (row.businessRiskRemaringDays < 0) {
              return (
                <span style="color:red">{`已过期(${
                  row.businessRiskRemaringDays
                })`}</span>
              )
            }
            return <span>{row.businessRiskRemaringDays || '--'}</span>
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          showColumnItem: () =>
            this.judgePermission('vehicle_insurance_manage_list_record'),
          getOperateList: ({ row }) => {
            const result = []
            if (this.judgePermission('vehicle_insurance_manage_list_record')) {
              result.push({
                name: 'look',
                label: '查看历史保单',
                action: () => this.JumpPolicy(row),
              })
            }
            return result
          },
        },
      ],
      tableData: null,
      numArr: {
        insuranceStateCount: 0,
        strongRiskExpres30Days: 0,
        strongRiskExpired: 0,
        businessRiskExpres30Days: 0,
        businessRiskExpres: 0,
      },
      options: [],
      nullObj: {},
      CAR_MODEL_FILTER_SCENE,
    }
  },
  watch: {
    brandSeriesModel: {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.params.brandId = brandId
        this.params.seriesId = seriesId
        this.params.modelId = modelId
      },
      deep: true,
    },
  },
  mounted() {
    this.getSummary(this.nullObj)
    this.getList(this.params)
    this.$refs['BLM-search'].searchMoreClick()
  },
  methods: {
    /* tab切换 */
    handleClick(tab) {
      if (parseInt(tab.name, 10) === this.params.tagTyp) return
      this.clearSearchParams()
      this.params.tagType = parseInt(tab.name, 10)
      this.pageNum = 1
      this.getList(this.params)
    },
    /* 分页 */
    paginationEvent({ pagination }) {
      this.params.pageSize = pagination.pageSize
      this.params.pageNum = pagination.pageNum
      this.getList(this.params)
    },
    /* 车险统计 */
    async getSummary(res) {
      const { data } = await insuranceSummary(res)
      if (data) {
        this.numArr = data
      }
    },
    /* 获取列表 */
    async getList(res) {
      const params = {
        ...res,
      }
      this.oLoading.search = true
      try {
        const { code, data } = await insuranceList(params)
        this.oLoading.search = false
        if (code === 1) {
          this.tableData = data.items
          this.total = data.totalNum
        }
      } catch {
        this.oLoading.search = false
      }
    },
    /* 跳转保单 */
    JumpPolicy(data) {
      this.$router.push({
        path: '/vehicle/insurance/insurancePolicy',
        query: {
          plateNo: data.plateNo,
        },
      })
    },
    /* 跳转车辆详情 */
    JumpCarEdit(data) {
      this.$router.push({
        path: '/vehicle/vehicleManage/detail',
        query: { id: data.carId },
      })
    },
    /* 查询 */
    selectBtn() {
      this.params.pageNum = 1
      this.getList(this.params)
    },
    /* 车辆模糊搜索 */
    async remoteMethod(query) {
      if (query.length >= 4) {
        this.oLoading.fuzzy = true
        try {
          const { code, data } = await FuzzySearch({
            state: 1,
            plateNo: query,
          })
          this.oLoading.fuzzy = false
          if (code === 1) {
            this.options = data
          }
        } catch (error) {
          this.oLoading.fuzzy = false
        }
      }
    },
    /* 重置 */
    Reset() {
      this.clearSearchParams()
      this.getList(this.params)
    },
    clearSearchParams() {
      this.$refs.paramsList.resetFields()
      this.$refs.carBrandSeriesModelRef.reset()
      this.brandSeriesModel = {}
      this.options = []
      this.params.pageSize = 10
      this.params.pageNum = 1
    },
  },
  computed: {
    paginationData() {
      return {
        pageSize: this.params.pageSize,
        pageNum: this.params.pageNum,
        total: this.total,
        pageSizes: [10, 20, 30, 50],
      }
    },
    exportParams() {
      return this.params
    },
  },
}
</script>
<style lang="less" scoped>
.el-tabs {
  font-size: 14px;
}
.selectBox {
  .btnText {
    padding-top: 5px;
    font-size: 14px;
    color: #2e7eff;
  }
}
.content {
  max-height: 500px;
  font-size: 14px;
}
</style>
